export const normalizeProhorText = (value = "") =>
    String(value)
        .toLowerCase()
        .replace(/ё/g, "е")
        .replace(/[!?.,;:()[\]{}"«»'`–—-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

export const matchesProhorIntent = (normalizedText, intent) => {
    if (Array.isArray(intent.matchRegex)) {
        if (intent.matchRegex.some((re) => re.test(normalizedText))) {
            return true;
        }
    }
    if (!Array.isArray(intent.matchAll) || !intent.matchAll.length) {
        return false;
    }
    return intent.matchAll.some((terms) =>
        terms.every((term) => normalizedText.includes(term))
    );
};

export const prohorRoleAnswerKey = (role) => {
    if (["superadmin", "admin"].includes(role)) return "hrMain";
    if (role === "hr_department") return "hrSub";
    if (["staff", "private_person"].includes(role)) return "staff";
    return null;
};

export const findProhorIntentReply = (question, role, intents) => {
    const normalized = normalizeProhorText(question);
    if (!normalized) return null;

    const sorted = [...intents].sort(
        (a, b) => (b.priority ?? 0) - (a.priority ?? 0)
    );
    const intent = sorted.find((item) => matchesProhorIntent(normalized, item));
    if (!intent) return null;

    const key = prohorRoleAnswerKey(role);
    if (!key || !intent.roles[key]) return null;

    const answer = intent.roles[key];
    return {
        intentId: intent.id,
        text: answer.text,
        action: answer.action ?? null,
        actions: answer.actions ?? null,
    };
};
